export default "__VITE_ASSET__6f8346b7__"